// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-size-8[data-v-6f9867c8] {\n  font-size: 0.65rem !important;\n}\n.borderd-box[data-v-6f9867c8] {\n  border: 1px solid gainsboro;\n}", ""]);
// Exports
module.exports = exports;
